import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';

export const CURRENCY_INFO_SCHEMA = Object.freeze({
  CURRENCY_CODE: '',
  AVAILABLE_CURRENCY_CODES: List<string>([]),
});
const RECORD = generateSchema(CURRENCY_INFO_SCHEMA);
const KEYS: any = generateKeys(CURRENCY_INFO_SCHEMA);

export class CurrencyInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.AVAILABLE_CURRENCY_CODES,
        value: props.get(KEYS.AVAILABLE_CURRENCY_CODES)
          ? List(this.availableCurrencyCodes).map((value) => value.toString())
          : List<string>([]),
      },
    ]);

    return selfModel as CurrencyInfo;
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get availableCurrencyCodes(): List<string> {
    return this.get(KEYS.AVAILABLE_CURRENCY_CODES);
  }
}
